import { PRODUCT_LINK_IN_BIO } from '@/constants';
import { useSpaceIDFromPath } from '@/data/space/hooks';
import { useListPagesQuery } from '@/store';
import { LinkSimple } from '@phosphor-icons/react';
import { IPage } from '@typedream/data';
import { useMemo } from 'react';
import { MenuNav } from '../Nav';

export function MenuLinkInBio() {
  const spaceID = useSpaceIDFromPath();
  const { data: pagesData } = useListPagesQuery([String(spaceID)], {
    skip: !spaceID,
  });

  const linkInBioContent = useMemo(() => {
    let pages: IPage[];
    if (pagesData) {
      pages = Object.values(pagesData).filter(
        (p) => p?.metadata?.page_type === PRODUCT_LINK_IN_BIO
      );
    }
    return pages;
  }, [pagesData]);

  return (
    <div className="mb-[24px]">
      {linkInBioContent?.map((item) => (
        <MenuNav
          key={item.id}
          href={`/link/s/${spaceID}/${item.id}`}
          pre={<LinkSimple size={16} weight="bold" className="text-secondary" />}
        >
          {item.name}
        </MenuNav>
      ))}
    </div>
  );
}
